// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"iv_a bhe_je","CommentListPlaceholder--Legacy":"iv_b bhe_qh bhe_vk"};